import { useEffect } from "react";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import { guestApi } from "@/lib/api";
import { getBookingDraft } from "@/lib/bookingDraft";

export default function BookingCancelled() {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");
  const draft = getBookingDraft();
  const propertySlug = draft?.propertySlug;
  const retryUrl = propertySlug
    ? `/booking/review/${propertySlug}?check_in=${encodeURIComponent(draft.checkIn || "")}&check_out=${encodeURIComponent(draft.checkOut || "")}&guests=${encodeURIComponent(draft.guests || 1)}`
    : "/properties";
  const propertyUrl = propertySlug ? `/properties/${propertySlug}` : "/properties";

  useEffect(() => {
    if (!bookingId) return;

    // Stripe Checkout was cancelled, so release the pending-payment inventory
    // hold immediately instead of waiting for its normal expiry window.
    guestApi.cancelPayment(bookingId).catch(() => {
      // The hold will still expire server-side; cancellation is best-effort here.
    });
  }, [bookingId]);

  return (
    <main className="mx-auto min-h-[75vh] max-w-[820px] px-5 py-20 text-center md:px-10 md:py-28">
      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Payment not completed</p>
      <h1 className="mt-4 font-display text-5xl font-medium tracking-tight md:text-7xl">Your booking has not been charged.</h1>
      <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
        The checkout was closed or could not be completed. Your stay is not confirmed, and the temporary payment hold is being released so you can safely try again.
      </p>

      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Link to={retryUrl} className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground">
          <RefreshCw size={16} /> Try again
        </Link>
        <Link to={propertyUrl} className="inline-flex items-center gap-2 rounded-full border border-foreground/15 px-6 py-3 text-sm font-medium">
          <ArrowLeft size={16} /> Go back to property
        </Link>
      </div>

      <p className="mt-8 text-xs text-muted-foreground">No successful Stripe confirmation means the booking is not confirmed.</p>
    </main>
  );
}
